import styled from 'styled-components'

export const StyledLonPageHelper = styled.div`
  background: #f6f8fb;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  .flex-row-around {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-around !important;

    > div {
      flex: 1;
    }
  }

  p {
    margin: 0;
  }
  a,
  button {
    cursor: pointer;
  }
  .row {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
  }

  .flex-column-center {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
  }

  .lon-card {
    padding: 0;
    border: 0.5px solid #20203d;
    box-sizing: border-box;
    border-radius: 12px;
    margin-top: 20px;
    background: #373756;

    .flex-row-between {
      padding: 15px 20px;
      background: #2c2c4d;
      &:last-child,
      &:nth-last-child(2) {
        border-bottom-left-radius: 12px;
        border-bottom-right-radius: 12px;
      }
      /* &:last-child {
        background: #373756;
      } */
    }

    &--light {
      background: #fff;
      border: none;

      .flex-row-between {
        background: #fff;
        border: none;
      }

      .button--light,
      a.button--light,
      a.button.button--light {
        background-color: rgba(95, 77, 188, 0.1);
        color: #5f4dbc;
      }

      .button--dark {
        background-color: #5f4dbc;
        color: #fff;
      }
    }

    .divider-wrap {
      background: #2c2c4d;

      &--light {
        background: transparent;

        .divider {
          width: calc(100% - 40px);
          margin: 0 auto;
        }
      }

      .divider {
        width: calc(100% - 40px);
        margin: 0 auto;
      }
    }
  }

  .lon-cell {
    width: 375px;
    height: 105px;
    background: #2c2c4d;
    border: 0.5px solid #373756;
    box-sizing: border-box;
    box-shadow: 0px 4px 20px rgba(57, 53, 92, 0.3);
    border-radius: 12px;
    margin: 10px;
    padding: 25px 24px 28px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    dd {
      font-size: 14px;
      line-height: 20px;
      color: #ffffff;
      opacity: 0.5;
      margin-bottom: 0;
    }
    dt {
      font-weight: bold;
      font-size: 27px;
      line-height: 27px;
      color: #ffffff;
      margin-top: 10px;
    }
  }

  .flex-row-between,
  .flex-row-around {
    width: 750px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;

    &.dually {
      .mobile-divider {
        display: none;
      }
    }

    dd {
      font-size: 11px;
      line-height: 13px;
      color: #9598ab;
      margin-bottom: 0;
    }

    dt {
      font-weight: bold;
      font-size: 17px;
      line-height: 21px;
      color: #ffffff;
      margin-top: 9px;
      margin-bottom: 2px;
    }

    button,
    a.button {
      margin: 0;
      border: 0;
      outline: none;
      height: 32px;
      border-radius: 16px;
      font-size: 15px;
      line-height: 32px;
      text-align: center;
      color: #ffffff;
      background: rgba(255, 255, 255, 0.1);
      padding: 0 15px;
      cursor: pointer;
      white-space: nowrap;
      display: inline-block;

      &.primary {
        background: #5f4dbc;
        height: 36px;
        line-height: 36px;
        border-radius: 18px;
        padding: 0 45px;
      }
    }
  }

  .exchange-header-wrap {
    background: white;
  }

  .normal-wrap {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    width: 1200px;
  }

  .divider {
    width: 100%;
    height: 1px;
    background: #252548;
    margin: 15px 0;

    &.light {
      background: white;
      opacity: 0.05;
      width: calc(100% - 40px);
    }

    &.gray {
      background-color: rgba(32, 32, 61, 0.1);
    }
  }

  .footer-wrap {
    background: white;
    a {
      text-decoration: none;
    }
  }

  .lon-inner-wrap {
    width: 1200px;
    margin: 0 auto;
    padding: 30px 0 80px;
    flex: 1;
  }
  .sub-nav {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
  }
  dt.reward-value {
    color: #43454f;
  }
  @media screen and (max-width: 960px) {
    min-height: 100vh;
    .flex-row-between,
    .flex-row-around {
      width: unset;
    }
    .exchange-header-wrap {
      display: none;
    }

    .footer-wrap {
      display: none;
    }

    .lon-inner-wrap {
      width: 100%;
      padding: 0 15px 30px;

      .flex-row-between.dually,
      .flex-row-between.single {
        flex-flow: row wrap;
        > div {
          width: 50%;
        }
        .mobile-divider {
          display: block;
          height: 1px;
          width: 100%;
          background: #20203d;
          margin: 13px 0;
        }
      }

      .lon-card {
        width: 100%;
        > div {
          width: 100%;
        }
      }
      .mine {
        .lon-cell {
          width: 100% !important;
        }
      }
    }

    dt.reward-value {
      color: #43454f;
    }
  }
`

export const StyledLonDashboard = styled.div`
  margin: 0 auto;
  position: relative;
  background: #f6f8fb;
  padding: 0 10px 20px;
  width: 100%;
  margin-bottom: 77px;

  .lon-dashboard-inner {
    width: 1200px;
    min-width: 1200px;
    margin: 0 auto;
    margin-top: 43px;
  }
  #tokenlon-modal {
    position: absolute;
    top: 18%;
  }
  h3,
  p {
    margin: 0;
  }

  .lon-cell {
    background-color: #fff;
    border: 0.5px solid #eaecf6;
    box-shadow: none;
    color: #191c1e;

    dd {
      color: #9598ab;
      opacity: 1;
    }

    dt {
      color: #191c1e;
    }
  }

  .logo-wrap {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    color: white;
    padding: 15px;

    > div:first-child {
      background: white;
      width: 56px;
      height: 56px;
      border-radius: 50%;
      padding: 8px;
      box-sizing: border-box;
      img {
        width: 40px;
        height: 40px;
      }
    }

    .name-wrap {
      margin-top: 10px;
      .title {
        font-weight: 800;
        font-size: 17px;
        line-height: 20px;
        color: #2c2c4d;
      }
      .subtitle,
      .divider {
        font-size: 15px;
        line-height: 20px;
        color: #9aa3ae;
      }
      .subtitle {
        margin-left: 0;
      }
      .divider {
        margin: 0 5px;
      }
    }

    .round-time {
      font-size: 11px;
      line-height: 16px;
      color: #9598ab;
      margin-top: 8px;
    }
  }

  .divide-title {
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #9aa3ae;
    margin: 30px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
  }

  .overview {
    .overall {
      display: flex;
      flex-flow: row wrap;
      align-items: center;
      justify-content: flex-start;
      padding-left: 10px;
    }

    .mine,
    .mining {
      display: flex;
      flex-flow: row wrap;
      align-items: center;
      justify-content: flex-start;
      padding-left: 10px;
      .lon-cell {
        dt {
          color: #f0bf70;
        }

        &.red {
          dt {
            color: #e15b66;
          }
          button {
            color: #e15b66;

            &.primary {
              color: #fff;
              padding: 0 18px;
              background-color: #5f55a9;
              border-radius: 45px;
            }
          }
        }
        .tip {
          font-size: 27px;
          line-height: 27px;
          color: #999;
          margin-top: 10px;
          cursor: pointer;
        }
        .status-pill {
          background: rgba(255, 255, 255, 0.7);
          line-height: 20px;
          padding: 0 10px;
          border-radius: 10px;
          color: #f0bf70;
          display: inline-block;
          font-size: 12px;
          margin-left: 5px;
        }

        button {
          border: 0;
          outline: none;
          height: 32px;
          line-height: 32px;
          border-radius: 16px;
          padding: 0 30px;
          background: rgba(255, 255, 255, 0.4);
          color: rgba(255, 255, 255, 0.7);
          font-size: 15px;
        }
      }
    }

    .mining {
      display: flex;
      flex-flow: row wrap;
      align-items: center;

      .mining-cards {
        display: flex;
        flex-flow: row wrap;
        align-items: center;
      }
      .mining-card {
        cursor: pointer;
        height: 105px;
        position: relative;

        > div {
          display: flex;
          flex-flow: row nowrap;
          align-items: center;

          .m-icon {
            width: 55px;
            height: 55px;
          }

          p {
            align-items: center;
            color: #191c1e;
            display: flex;
            font-size: 21px;
            font-weight: 500;
            letter-spacing: 0.02em;
            line-height: 21px;
            margin-left: 16px;
          }
        }

        &.inactive {
          p,
          img {
            opacity: 0.2;
          }
        }

        &:active,
        &:focus {
          &::after {
            background: #191c1e;
            border-radius: 12px;
            content: '';
            height: 100%;
            left: 0;
            opacity: 0.15;
            position: absolute;
            top: 0;
            width: 100%;
          }
        }
      }
    }
  }
  @media screen and (max-width: 960px) {
    -webkit-overflow-scrolling: touch;
    width: 100%;
    box-sizing: border-box;
    padding: 0 10px 80px 10px;

    .logo-wrap > div:first-child {
      width: 45px;
      height: 45px;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .lon-dashboard-inner {
      width: 100%;
      min-width: unset;
      margin-top: 0;
    }

    .logo-wrap {
      flex-flow: row nowrap;
      .name-wrap {
        flex-flow: column nowrap;
        align-items: flex-start;
        padding-left: 15px;
        span:nth-child(2) {
          display: none;
        }
      }
    }

    .row {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: space-between;

      .event-time {
        font-size: 12px;
        line-height: 17px;
        color: rgba(255, 255, 255, 0.7);
        margin-left: 10px;
      }
    }

    .row-start {
      justify-content: flex-start;
      padding: 10px 0;
    }

    .divide-title {
      margin: 20px 0;
      font-size: 11px;
      line-height: 16px;
    }

    .card {
      background: #2c2c4d;
      border: 0.5px solid rgba(255, 255, 255, 0.05);
      box-sizing: border-box;
      border-radius: 12px;
      padding: 20px 20px 25px 20px;
      height: 85px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .col {
        .key {
          font-size: 11px;
          line-height: 16px;
          color: #9598ab;
        }

        .value {
          font-size: 21px;
          line-height: 22px;
          color: white;
          font-weight: bold;
          margin-top: 5px;
        }

        .status-pill {
          background: rgba(255, 255, 255, 0.7);
          line-height: 20px;
          padding: 0 10px;
          border-radius: 10px;
          color: #f0bf70;
          display: inline-block;
          font-size: 12px;
          margin-left: 5px;
        }
      }

      .status-pill-wrap {
        .status-pill {
          margin-top: 0;
        }
      }

      &.minted {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: space-between;
      }

      &.tokenlon-vol {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: space-between;
        margin-top: 10px;
      }

      &.tip-card {
        .key {
          color: #eaecf6;
        }
        .tip {
          font-size: 27px;
          line-height: 27px;
          color: rgba(255, 255, 255, 0.8);
          margin-top: 10px;
          cursor: pointer;
        }
      }

      &.my-share {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: space-between;
        background: #f0bf70;

        .col {
          .key {
            color: #eaecf6;
          }
        }
      }

      &.this-week {
        margin-top: 10px;
        background: #e15b66;

        .col {
          .key {
            color: #eaecf6;
          }
          .status-pill {
            color: #e15b66;
          }
        }
      }

      &.faq {
        margin-top: 10px;
        height: 60px;
        padding: 20px;
        text-decoration: none;
        color: white;
        span {
          font-size: 15px;
          line-height: 21px;
          color: #ffffff;
          text-decoration: none;
        }
      }

      &.records {
        background: #5f4dbc;
        margin-top: 10px;
        padding: 20px;

        .reward-record {
          width: 100%;
          text-decoration: none;
          p {
            font-weight: bold;
            font-size: 21px;
            line-height: 21px;
            color: #ffffff;
          }
        }
      }
    }

    .overview {
      .overall {
        padding: 0;
        .lon-cell {
          width: 100%;
          height: 85px;
          box-sizing: border-box;
          margin: 5px 10px;

          div {
            dd {
              font-size: 11px;
              line-height: 16px;
              margin-bottom: 0;
            }
            dt {
              font-size: 21px;
              line-height: 21px;
              margin-top: 6px;
            }
          }

          &:last-child,
          &:nth-last-child(2),
          &:nth-last-child(3) {
            display: none;
          }
        }
      }
      .divide-title {
        margin-bottom: 12px;
      }
      .mine {
        padding-left: 0;
        padding-bottom: 0;
        .lon-cell {
          height: 85px;
          width: 100%;
          &.red {
            margin-top: 0;
          }
          div {
            dd {
              font-size: 11px;
              line-height: 16px;
            }
            dt {
              font-size: 21px;
              line-height: 21px;
              margin-top: 10px;
            }
          }
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
      .mining {
        padding: 0 5px;
        .lon-cell {
          padding: 20px 15px;
          height: 85px;
          margin-left: 0;
          &.mining-card {
            > div {
              .m-icon {
                width: 36px;
                height: 36px;
              }
              p {
                color: #191c1e;
                font-size: 14px;
                font-weight: normal;
                line-height: 21px;
                margin-left: 8px;
              }
            }
          }
        }
        .mining-cards {
          flex-flow: column nowrap;
          justify-content: space-around;
          gap: 16px;
          margin-top: 16px;
          padding: 0;
          width: 100%;

          .mining-card {
            width: calc(100% - 10px);
            margin: 0;
          }
        }
      }
    }
  }
`

export const StyledBadge = styled.span<{ bgColor?: string }>`
  display: inline-block;
  font-weight: 400;
  font-size: 13px;
  line-height: 140%;
  color: #ffffff;
  padding: 2px 8px;
  background: ${({ bgColor }) => (bgColor ? `${bgColor}` : '#e75b55')};
  border-radius: 20px;
  margin-top: 12px;
  margin-left: 16px;

  ${({ theme }) => theme.media.sm`
    font-size: 12px;
    margin-top: 8px;
    margin-left: 8px;
  `}
`
